import { CreateTempUserRequestPayload } from "@/data/payload/user/create-temp-user-request-payload";
import { CreateTempUserResponseEntity } from "@/domain/entity/user/create-temp-user-response-entity";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CreateTempUserUsecase {
  constructor(private readonly userRepo: UserRepository) {}

  async execute(
    payload: CreateTempUserRequestPayload,
  ): Promise<SATResult<CreateTempUserResponseEntity, SATError>> {
    return this.userRepo.createTempUser(payload);
  }
}
